export default __webpack_public_path__ + "static/media/InstructorImage.0f048b44.svg";